import axiosConfig from "./axiosConfig";

// One saved search's frozen row set. Fetched only when a surface needs the refs
// themselves - the history list returns counts, not arrays, because every
// stored `sourceRefs` across 200 searches is an unbounded read.
export interface LeadSearchDetail {
  id: string;
  name: string;
  // What `sourceRefs` holds: VOA assessment refs, or platform site ids.
  sourceKind: "voa" | "existing_sites";
  // The `lead.source` a promote from this search writes. Resolved by the
  // backend rather than mapped here, because the history list's promoted count
  // joins on the same value - a copy of the mapping is how the count and this
  // filter would stop agreeing.
  leadSource: string;
  sourceRefs: string[];
}

const getLeadSearch = async (
  authToken: string,
  searchId: string
): Promise<LeadSearchDetail> => {
  const { data } = await axiosConfig.get(
    `/leads/searches/${encodeURIComponent(searchId)}`,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default getLeadSearch;
